import type { RegistrationSiteSettings } from '../../registration.types.ts';
import { UK_LEGACY_REGISTRATION_REDIRECT } from './legacyRegistrationRedirect.ts';
import { PHONE_NUMBER } from './phoneNumber.ts';

const UK_POSTCODE_PATTERN = /^[A-Z]{1,2}[0-9][A-Z0-9]? ?[0-9][A-Z]{2}$/i;

const REGISTRATION: RegistrationSiteSettings = {
  country: PHONE_NUMBER.country,
  defaultPhonePrefix: PHONE_NUMBER.defaultPrefix,
  language: 'en-GB',
  phonePlaceholder: PHONE_NUMBER.placeholder,
  postcodePattern: UK_POSTCODE_PATTERN,
  states: [],
  requirePrivacyPolicyAcceptance: true,
  marketingConsentFromPrivacyPolicy: false,
  collectsAddressLine2: true,
  showsStateSelect: false,
  showsGamblingMarketingPreferenceSteps: true,
  usesObRedirectForAcquisitionCode: true,
  legacyRegistrationRedirect: UK_LEGACY_REGISTRATION_REDIRECT,
  isDailyFirstPeriodOrder: false,
  usesClassifiedRegistrationErrorStep: false,
  tracking: {
    termsCheckboxName: 'Terms and Conditions',
    privacyCheckboxName: 'Privacy Policy',
    successAttributes: 'preferences',
    depositLimitsStep: '7',
  },
};

export { REGISTRATION };
